import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { MuralModel } from 'src/app/model/mural';


@Component({
  selector: 'app-dialog-data-diario',
  templateUrl: './dialog-data-diario.component.html',
  styleUrls: ['./dialog-data-diario.component.css']
})
export class DialogDataDiarioComponent implements OnInit {

  public isVisibleText;
  public isVisibleImg;
  constructor(public dialogRef: MatDialogRef<DialogDataDiarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MuralModel) { }

  ngOnInit(): void {
    this.isVisibleText = true;
    this.isVisibleImg = false;
  }


  radioChange(event: MatRadioChange) {
    this.isVisibleText = event.source.value === "1";
    this.isVisibleImg = event.source.value === "2";
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
